import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-printable-vehicle-list',
  templateUrl: './printable-vehicle-list.component.html',
  styleUrls: ['./printable-vehicle-list.component.css']
})
export class PrintableVehicleListComponent {
  public errorMessage: string | null = null;
  public warningMessage: string | null = null;
  @Input() data: any[] = [];
  @Input() columns: string[] = [];
  visibleColumns: { [key: string]: boolean } = {};

  constructor() {
    // Initialize visibleColumns to show all columns by default
    this.columns.forEach(column => {
      this.visibleColumns[column] = true;
    });
  }

  toggleColumn(column: string) {
    this.visibleColumns[column] = !this.visibleColumns[column];
  }
}
